import { Api, i18n } from "@/@core";
import { Configuration } from "@/@core/configuration";
import { SmartSignFormData } from "@/@modules/fseg/services/interfaces/SmartSignFormData";

const api = new Api("smartsign");

export class SmartSignFormService {
  private static async getApplication(): Promise<string> {
    return (await api.get<string>("application")).data;
  }

  private static async getApplicationAuthToken(): Promise<string> {
    return (await api.get<string>("application-auth-token")).data;
  }

  public static async getIbanCr(iban?: string, bic?: string): Promise<any> {
    let options = null;
    if (iban) {
      options = { iban: iban, bic: bic };
    }
    try {
      return (await api.get<any>(`iban-cr`, options)).data;
    } catch (e) {
      return null;
    }
  }

  private static getUrl() {
    return (
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port == "4200" ? ":4200" : "") +
      process.env.BASE_URL
    );
  }

  public static async submit(signatureRequest: string, targetArgs: any, expectedSigner?: string) {
    const url = await Configuration.get<any>("smartsignUrl");
    const action = url + "api/sign";

    const data = {} as SmartSignFormData;
    data.adesLevel = "LEVEL_T";
    data.application = await this.getApplication();
    data.applicationAuthToken = await this.getApplicationAuthToken();
    data.documentId = "documentId";
    data.enableVisualSignature = false;
    // data.hideEMailAndPhoneField = false;
    // data.hideLocationField = false;
    data.locale = i18n.locale + "-be";
    data.responseEncType = "application/x-www-form-urlencoded";
    data.signatureRequest = signatureRequest;
    // data.signType = "SmartSignWithSMARTSIGN_ALT_ACC";
    data.target =
      this.getUrl() +
      Object.keys(targetArgs)
        .reduce((previous, current) => `${previous}${current}=${targetArgs[current]}&`, "api/smartsign/target?")
        .slice(0, -1);
    data.timeout = 180;
    // data.visualSignatureLocation = "101.0-225.0@1";
    expectedSigner && (data.expectedSigner = expectedSigner);

    const form = Object.assign(document.createElement("form"), {
      method: "post",
      action: action,
      enctype: "application/x-www-form-urlencoded",
    });
    Object.keys(data).forEach(key =>
      form.appendChild(
        Object.assign(document.createElement("input"), {
          name: key,
          value: (data as any)[key],
          type: (data as any)[key] instanceof File ? "file" : "text",
        })
      )
    );
    document.body.appendChild(form).submit();
  }
}
